// extracted by mini-css-extract-plugin
export default {"feedback":"feedback--NojpZ","line":"line--iAR1Y","link":"link--pI4Gf","bigLink":"bigLink--ZjKfu link--pI4Gf","version":"version--xQKPL"};